module.exports = __webpack_public_path__ + "img/PTC_SolanaTradingdiagram.424d756d.webp";